import { render, staticRenderFns } from "./EditSubscriptionPlan.vue?vue&type=template&id=cb5ce2cc&scoped=true"
import script from "./EditSubscriptionPlan.vue?vue&type=script&lang=ts"
export * from "./EditSubscriptionPlan.vue?vue&type=script&lang=ts"
import style0 from "./EditSubscriptionPlan.vue?vue&type=style&index=0&id=cb5ce2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5ce2cc",
  null
  
)

export default component.exports